module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.6f1e8cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.ttf
// module id = Ajvc
// module chunks = 13 14